import "./src/styles/global.css"

const GA_TRACKING_ID = "G-54EB6XHQNQ"

const loadGtag = () => {
  if (window.__gtagLoaded) return
  window.__gtagLoaded = true

  if (
    navigator.doNotTrack === "1" ||
    window.doNotTrack === "1" ||
    navigator.msDoNotTrack === "1"
  ) {
    return
  }

  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag = gtag
  gtag("js", new Date())
  gtag("config", GA_TRACKING_ID, {
    anonymize_ip: true,
    cookie_flags: "SameSite=Lax;Secure",
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
    send_page_view: true,
  })
}

const scheduleGtag = () => {
  if (typeof window === "undefined") return
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(loadGtag, { timeout: 4000 })
  } else {
    setTimeout(loadGtag, 2500)
  }
}

export const onClientEntry = () => {
  if (typeof window === "undefined") return
  if (document.readyState === "complete") {
    scheduleGtag()
  } else {
    window.addEventListener("load", scheduleGtag, { once: true })
  }
}

export const onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined" || !window.gtag) return
  const path = location.pathname
  if (path === "/404" || path === "/404.html" || path === "/404/") return
  window.gtag("event", "page_view", {
    page_path: path + location.search + location.hash,
    page_location: window.location.href,
    page_title: document.title,
  })
}
